/* ==========================================================================
   SearcherPackagesFerry > Passenger
   ========================================================================== */

/* Modules */
const InputClient = require('@bluekiri/alexandria-contrib-components/components/input/client/js');
const literals = require('@bluekiri/alexandria-contrib-components/literals/searcher/prototype');
const UiPanelVehicleFerryClient = require('../../../ui-panel-vehicle-ferry/client/js');
const config = require('./config');

const getTrigger = instance => instance.trigger;

const language = 'es';

/*
   Vehicle
   ========================================================================== */

const getVehicle = instance => instance.panel.vehicle.vehicle.product;
const getTrailer = instance => instance.panel.vehicle.extra.toggle;

/* Init */
function initVehiclePet(selector, instance, configuration = {}) {
    /* Instance reference with trigger and panel */
    const result = {};

    /* Input */
    result.trigger = InputClient(
        `${instance.selector} [data-type="${config().type.uipanel.vehicle.trigger}"]`,
        configuration.trigger
    );

    /* Panel */
    result.panel = UiPanelVehicleFerryClient(selector, {
        panel: {
            autoStore: true,
            ...configuration,
            type: configuration.type,
            triggers: [
                instance.element.querySelector(
                    `${instance.selector} [data-type="${config().type.uipanel.vehicle.trigger}"]`
                )
            ]
        }
    });

    /* Add callbacks */
    getVehicle(result).config.onChange.push(() => updateVehiclePet.call(result, result));
    getVehicle(result).config.onChange.push(() => updateVehiclesLength.call(result, result));
    getVehicle(result).config.onChange.push(() => updateVehicleMeasuresDisabled.call(result, result));
    getTrailer(result).config.onChange.push(() => setTrailerValuesIfChecked.call(result, result));

    /* Init panel */
    updateVehiclePet(result);
    initializeVehicleExtra(result);

    /* Return the instance reference */
    return result;
}

/* Action to update passenger */
function updateVehiclePet(instance) {
    // updatePetMeasures(instance);
    /* Set trigger input value */
    getTrigger(instance)
        .set(buildVehiclePetInfo(getVehicle(instance).get()))
        .setActive();
}

function updateVehiclesLength(instance) {
    if (instance.panel.vehicle.vehicle.product.value === '10') {
        instance.panel.vehicle.vehicle.length.set('600');
    } else if (instance.panel.vehicle.vehicle.product.value === '9') {
        instance.panel.vehicle.vehicle.length.set('460');
    } else if (instance.panel.vehicle.vehicle.product.value === '12') {
        instance.panel.vehicle.vehicle.length.set('700');
    } else {
        instance.panel.vehicle.vehicle.length.set('350');
    }
}

function updateVehicleMeasuresDisabled(instance) {
    if (instance.panel.vehicle.vehicle.product.value === '0') {
        setDisabledAttribute(instance.panel.vehicle.vehicle.length.element.children[1]);
        setDisabledAttribute(instance.panel.vehicle.vehicle.height.element.children[1]);
    } else {
        removeDisabledAttribute(instance.panel.vehicle.vehicle.length.element.children[1]);
        removeDisabledAttribute(instance.panel.vehicle.vehicle.height.element.children[1]);
    }
}

function initializeVehicleExtra(instance) {
    instance.panel.vehicle.vehicle.length.set('350');
    instance.panel.vehicle.vehicle.height.set('160');
    setDisabledAttribute(instance.panel.vehicle.vehicle.length.element.children[1]);
    setDisabledAttribute(instance.panel.vehicle.vehicle.height.element.children[1]);
}

function setDisabledAttribute(field) {
    field.setAttribute('disabled', 'disabled');
}

function removeDisabledAttribute(field) {
    field.removeAttribute('disabled');
}

function setTrailerValuesIfChecked(instance) {
    if (instance.panel.vehicle.extra.toggle.isChecked()) {
        instance.panel.vehicle.extra.height.set('10');
        instance.panel.vehicle.extra.length.set('10');
    } else {
        instance.panel.vehicle.extra.height.set('');
        instance.panel.vehicle.extra.length.set('');
    }
}

/* Build the string for vehicle pet input info */
function buildVehiclePetInfo(vehicle = {}, pet = {}) {
    /* Vehicle */
    const text = `${vehicle.label}`;

    /* Pet */
    if (Number(pet.value) !== 0 && !Number.isNaN(Number(pet.value))) return `${text} ${literals(language).mascota}`;

    return text !== '' ? text : literals(language).ninguno;
}

function refreshDiscounts(rsData, instance) {
    const { accommodation } = instance.passenger.panelAccommodation;
    const discountsTitle = accommodation.element.getElementsByClassName(
        'panel-accommodation-packages__agroupation-title'
    )[0];

    let discounts = {};
    if (instance.passenger.panelAccommodation.accommodation.resident) {
        discounts = refreshSingleDiscounts(
            rsData.residents,
            instance.passenger.panelAccommodation.accommodation.resident
        );
    }

    let bonuses = {};
    if (instance.passenger.panelAccommodation.accommodation.bonuses) {
        bonuses = refreshSingleDiscounts(rsData.discounts, instance.passenger.panelAccommodation.accommodation.bonuses);
    }

    if (discounts && !bonuses) {
        discountsTitle.classList.add('hidden');
    } else if (discountsTitle) discountsTitle.classList.remove('hidden');
    return true;
}

function refreshSingleDiscounts(discountsArray, select) {
    const discountMap = discountsArray.map(discount => mapDiscount(discount));

    select.choices.setChoices(discountMap, 'value', 'label', true);
    select.element.classList.remove('is-hidden');
    select.element.previousSibling.classList.remove('is-hidden');

    if (discountMap.length < 2) {
        select.element.previousSibling.classList.add('is-hidden');
        select.element.classList.add('is-hidden');
        return false;
    }
    return true;
}

function mapDiscount(discount) {
    return {
        name: discount.name,
        label: discount.name,
        value: discount.type
    };
}

module.exports = {
    initVehiclePet,
    refreshDiscounts
};
